import { redirect } from 'react-router-dom';
import { authGuard } from './auth-guard';
import { getCurrentUser, getUserServerRole } from '../stores/auth-store';
import type { Member } from '@/models/member';
import { MemberRole } from '@/models/member';

interface ServerData {
  server: { members: Member[] };
  channel: { isPrivate: boolean };
}

/**
 * Guard for checking roles when accessing private channels
 * Only ADMIN or MODERATOR can access private channels
 */
export const withRoleGuard = <T = unknown>(loader: (args: any) => Promise<T>) => {
  return async (args: any): Promise<T> => {
    await authGuard();

    const currentUser = getCurrentUser();
    if (!currentUser) {
      throw redirect('/auth/login');
    }

    const response = await loader(args);

    const { server, channel } = response as ServerData;

    if (!channel.isPrivate) {
      // If channel not private → ALL have access
      return response;
    }

    const role = getUserServerRole(server, currentUser.id);

    if (role !== MemberRole.ADMIN &&
      role !== MemberRole.MODERATOR &&
      role !== MemberRole.PRIVATE) {
      throw redirect('/'); // No access to private channel
    }

    return response;
  };
};
